import { setCurrentClientIdForHeader } from '@/configs/axios'
import * as userClientService from '@/services/userClientService'
import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useClientStore = defineStore('client', () => {
  const currentClientId = ref<string | null>(null)
  const clientChangeKey = ref(0)
  const clientsLoading = ref(false)

  function setCurrentClient(id: string | null, bumpKey = true) {
    currentClientId.value = id
    setCurrentClientIdForHeader(id)
    if (bumpKey) clientChangeKey.value += 1
  }

  function resetState() {
    clientsLoading.value = false
    currentClientId.value = null
    setCurrentClientIdForHeader(null)
  }

  async function loadClientsFromApi() {
    if (clientsLoading.value) return
    clientsLoading.value = true
    try {
      const [firstPageRes, currentRes] = await Promise.all([
        userClientService.getMyClients(1, 1),
        userClientService.getCurrentClient(),
      ])
      const newId = currentRes.data?.id ?? firstPageRes.data?.listOfItems?.[0]?.id ?? null
      const previousId = currentClientId.value
      currentClientId.value = newId
      setCurrentClientIdForHeader(newId)
      if (previousId !== null && newId !== previousId) clientChangeKey.value += 1
    } catch {
      currentClientId.value = null
      setCurrentClientIdForHeader(null)
    } finally {
      clientsLoading.value = false
    }
  }

  return {
    currentClientId,
    clientChangeKey,
    clientsLoading,
    setCurrentClient,
    resetState,
    loadClientsFromApi,
  }
})
